import { render, staticRenderFns } from "./AuthCodeCallback.vue?vue&type=template&id=9d457710"
import script from "./AuthCodeCallback.vue?vue&type=script&lang=ts"
export * from "./AuthCodeCallback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports